"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.initialWhoAmIData = void 0;
const api_1 = require("@/api");
exports.initialWhoAmIData = {
    ready: false,
    id: 0,
    nickname: '',
    is_logged_in: false,
    is_certified: false,
    is_under_14: false,
    agent_agree: false,
    is_under_19: false,
    is_admin: false,
};
function default_1() {
    return __awaiter(this, void 0, void 0, function* () {
        return yield (0, api_1.getData)('/api/v1/members/whoami')
            .then(res => {
            if (res.status === 200) {
                const { result } = res.data;
                if (result.user) {
                    return Object.assign(Object.assign({}, result.user), { is_logged_in: result.is_logged_in, ready: true });
                }
                else {
                    return Object.assign(Object.assign({}, exports.initialWhoAmIData), { ready: true });
                }
            }
        })
            .catch(() => exports.initialWhoAmIData);
    });
}
exports.default = default_1;
